import { Model } from "@interfaces/model.interface";

export interface OutsideProcessContract extends Model {
	agreedLeadTime?: number;
	annualVolume?: number;
	contractAgreementDate?: Date;
	cost: number;
	cumulativeQuantity: number;
	escalationContactId?: number;
	isActive: boolean;
	minimumBatchQuantity?: number;
	minimumCharge?: number;
	outsourcedSpecificationId: number;
	partId: number;
	primaryContactId?: number;
	relatedDocuments: string;
	routerStage: number;
	supplierId: number;
}

export class OutsideProcessContract implements OutsideProcessContract {
	relatedDocuments = "[]";
	
	constructor(data?: Partial<OutsideProcessContract>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}